import { Link, useParams } from 'react-router-dom';
import Slider from "react-slick";
import { SlickArrowLeft, SlickArrowRight, SlickProps } from '../../../lib/Slick';
import { Loading } from '../../components/Loading';
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import { YoutubeBestItem } from './YoutubeBestItem';

export const HomeYoutubeBest = () => {
    const { school } = useParams();
    const { data: youtubeList, isLoading, isError } = useQuery({
        queryKey: ['home/best/video'],
        queryFn: () => Api.get(`/api/youtube/best`),
        staleTime: 1000 * 60 * 60,
        placeholderData: keepPreviousData
    });

    if (isLoading) return <Loading />;
    if (isError) return null;
    if (!youtubeList.data) return;
    if (youtubeList.data.length === 0) {
        return (
            <div className="no_data">
                <p>독서 영상이 없습니다.</p>
            </div>
        );
    }

    return (
        <div className="inner">
            <Link className="btn" to={`/${school}/video?best=Y`}>
                <span className="more">더보기</span>
            </Link>
            <Slider className="reading_video" {...SlickProps}
                slidesToShow={youtubeList.data.length < 4 ? youtubeList.data.length : 4}
                slidesToScroll={4}
                dots={false}
                prevArrow={<SlickArrowLeft cn="prev_btn _green" />}
                nextArrow={<SlickArrowRight cn="next_btn _green" />}
                responsive={[
                    { breakpoint: 1200, settings: { slidesToShow: youtubeList.data.length < 3 ? youtubeList.data.length : 3, slidesToScroll: 3 } },
                    { breakpoint: 1024, settings: { slidesToShow: youtubeList.data.length < 2 ? youtubeList.data.length : 2, slidesToScroll: 2 } },
                    { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } }]}
            >
                {youtubeList.data.map(item => <YoutubeBestItem item={item} key={item.id} />)}
            </Slider>
        </div>
    );
};
